<template>
  <div>
    <div v-if="type == 0">
      <div class="pay-info">
        <div class="title">
          <span class="span1">订单提交成功，请您尽快付款！订单号：</span>
          <span class="span2">{{ payList.sn }}</span>
          <span class="span3" @click="checkOrder">[查看订单]</span>
        </div>
        <!-- <div class="desc">
        <span>请您在提交订单后<i>24小时</i>内完成支付，否则订单会自动取消</span>
      </div>
      <div class="time">
        <span><img src="@/assets/images/icon_time.png"/>{{hr}}:{{min}}:{{sec}}</span>
        <span>商品库存消耗快，为确保正常出货，需尽快付款哦。</span>
      </div> -->
        <div class="price">
          <span class="span1">应付款金额：</span>
          <span class="span2">￥{{ payList.amount }}</span>
        </div>
      </div>
      <div class="pay-method">
        <div class="title">支付方式</div>
        <div class="pay-container">
          <div
            class="pay-item"
            v-for="(item, index) in payMethods"
            @click="selectPay(index, item)"
            :key="index"
            :class="index == selectIndex ? 'active' : ''"
          >
            <img v-lazy="item.icon" alt="" />
            <span>{{ item.title }}</span>
          </div>
        </div>
      </div>
      <div class="submit">
        <span class="submit-btn" @click="submit">确定提交</span>
      </div>
    </div>
    <cart-pay-method
      v-if="type == 1 && qrCode"
      :method="qrCode"
      @eventClick="goback"
      :select="paySelectIndex"
      :payList="payList"
      @refresh="refreshcode"
    ></cart-pay-method>
    <popup
      class="popup-info"
      width="400px"
      height="200px"
      @close="close"
      v-if="show"
    >
      <div class="title">是否确认货到付款订单</div>
      <div class="btn">
        <span class="span1" @click="Confirm">确定</span>
        <span class="span2" @click="close">取消</span>
      </div>
    </popup>
  </div>
</template>
<script>
import cartPayMethod from "./cart-pay-method.vue";
export default {
  components: { cartPayMethod },
  data() {
    return {
      payMethods: [
        { title: "货到付款", icon: require("@/assets/images/icon_goods1.png") },
        { title: "微信支付", icon: require("@/assets/images/icon_wechat.png") },
        {
          title: "支付宝支付",
          icon: require("@/assets/images/icon_alipay.png"),
        },
      ],
      selectIndex: 0,
      paySelectIndex:1,
      type: 0, //0,1
      payList: [],
      qrCode: "",
      show: false,
      //   hr: 0,
      //  min: 0,
      //  sec: 0,
      //  msec:1*24*60*60*1000
    };
  },
  created() {
    this.payList = {
      sn: this.$route.query.sn,
      amount: this.$route.query.amount,
      orderId: this.$route.query.orderId,
    };
  },
  mounted() {
    // this.countdown()
  },
  methods: {
    selectPay(index, item) {
      this.selectIndex = index;
    },
    submit() {
      console.log(this.selectIndex)
      if (this.selectIndex == 0) {
        this.show = true;
      } else if (this.selectIndex == 1) {
        this.type = 1;
        this.paySelectIndex = 0
        this.$api
          .GET_WEBPAYMENT({
            //微信支付
            orderId: this.payList.orderId,
            paymentMethod: "wexpayBarcodePaymentPlugin",
          })
          .then((res) => {
            if (res.status) {
              this.qrCode = "";
              this.qrCode = res.data.qrCode;
            } else {
            }
          });
      } else if (this.selectIndex == 2) {
        this.type = 1;
        this.paySelectIndex = 1

        this.$api
          .GET_WEBPAYMENT({
            //支付宝支付
            orderId: this.payList.orderId,
            paymentMethod: "alipayBarcodePaymentPlugin",
          })
          .then((res) => {
            if (res.status) {
              this.qrCode = "";

              this.qrCode = res.data.qrCode;
            } else {
            }
          });
      }
    },
    refreshcode() {
      //  console.log(this.selectIndex);
      this.submit();
    },
    goback() {
      this.type = 0;
    },
    checkOrder() {
      this.$router.push({
        path: "/person/orderdetail",
        query: { type: 1, sn: this.payList.sn },
      });
    },
        close(){
     this.show = false
    },
    Confirm() {
      this.$api.POST_ORDERCOD({//货到付款
           sn:this.payList.sn
        })
        .then((res) => {
          if (res.status) {
            this.$router.push({
              path: "/person/orderdetail",
              query: { type: 2, sn: this.payList.sn },
            });
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.pay-info {
  margin-bottom: 36px;
  height: 198px;
  background: #ffffff;
  border: 1px solid #f5f5f5;
  border-radius: 4px;
  padding: 35px 0 0 44px;
  .title {
    margin-bottom: 18px;
    .span1,
    .span2 {
      font-size: 16px;
      color: #505050;
    }
    .span3 {
      cursor: pointer;
      font-size: 14px;
      color: #fa4b4b;
    }
  }
  .desc {
    margin-bottom: 18px;
    font-size: 14px;
    color: #808080;
    i {
      color: #fa4b4b;
    }
  }
  .time {
    font-size: 14px;
    color: #808080;
    margin-bottom: 30px;
    img {
      margin-right: 8px;
      position: relative;
      top: 3px;
    }
  }
  .price {
    .span1 {
      font-size: 16px;
      color: #505050;
      margin-right: 2px;
    }
    .span2 {
      font-weight: 600;
      font-size: 24px;
      color: #fa4b4b;
    }
  }
}
.pay-method {
  height: 188px;
  border-radius: 4px;
  border: 1px solid #f5f5f5;
  .title {
    border-bottom: 1px solid #f5f5f5;
    padding-left: 24px;
    line-height: 58px;
    font-size: 16px;
    color: #505050;
    height: 58px;
    background: #fafafa;
  }
  .pay-container {
    padding: 32px 0 0 24px;
    .pay-item {
      position: relative;
      cursor: pointer;
      height: 68px;
      width: 188px;
      border-radius: 4px;
      border: 2px solid #fafafa;
      font-size: 16px;
      color: #3f3f4d;
      margin-right: 22px;
      float: left;
      @include flex-c;
      img {
        margin-right: 10px;
      }
    }
    .active {
      border: 2px solid #fa4b4b;
      &::after {
        content: "";
        position: absolute;
        right: -1px;
        bottom: -1px;
        width: 20px;
        height: 20px;
        background: url("../../../assets/images/icon_selected.png") no-repeat;
      }
    }
  }
}
.submit {
  text-align: right;
  margin: 34px 0;
  .submit-btn {
    cursor: pointer;
    height: 56px;
    width: 172px;
    border-radius: 2px;
    color: #ffffff;
    line-height: 56px;
    text-align: center;
    background: #fa4b4b;
    font-size: 18px;
    font-weight: 600;
    display: inline-block;
  }
}
.popup-info {
  .title {
    font-weight: 600;
    font-size: 16px;
    color: #333333;
    margin-top: 60px;
    text-align: center;
    margin-bottom: 38px;
  }
  .btn {
    text-align: center;
    span {
      @include btn(124px, 44px, #fa4b4b, #ffffff, 16px, 2px);
    }
    .span2 {
      border: 1px solid #fa4b4b;
      color: #fa4b4b;
      background: none;
      margin-left: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/cart/components/cart-pay.vue